module.exports = __webpack_public_path__ + "img/edge4.55fcf22b.jpg";